<template>
  <van-field
    class="nio-form-item"
    :value="value"
    ref="vanField"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #input>
      <slot v-bind:error="error" v-bind:message="message"></slot>
    </template>
  </van-field>
</template>

<script>
import { ref, watchEffect, onMounted, defineProps } from "vue";

export default {
  name: "NioFormItem",
  props: ['value', 'readonly'],
  setup(props) {
    const error = ref(false);
    const message = ref("");
    const vanField = ref(null);

    watchEffect(() => {
      if (!vanField.value) {
        return;
      }
      error.value = vanField.value.showError;
      message.value = vanField.value.validateMessage;
    });

    onMounted(() => {
      if (props.readonly) {
        vanField.value.$el.getElementsByTagName('input')[0].setAttribute('readonly', 'true');

      }
    });
    return {
      error,
      message,
      vanField,
    };
  },
};
</script>

<style lang="scss" scoped>
// .nio-form-item {
//   // padding-bottom: 20px;
// }
::v-deep {
  .van-field__error-message {
    display: none;
  }
}
</style>
